'use client';

import AboutWafra from "../organisms/home/About";
import ContactUs from "../organisms/contact-us/ContactUs";
import FeaturesSection from "../organisms/home/FeatureSection";
import GuideSection from "../organisms/home/GuideSection";
import { HeroSection } from "../organisms/home/HeroSection";
import TestimonialsSection from "../organisms/home/TestimonialSection";

export default function HomePage() {
  return (
    <div className="">
      <HeroSection />
      <AboutWafra/>
      <FeaturesSection/>
      <GuideSection/>
      <ContactUs />
      {/* <TestimonialsSection/> */}
    </div>
  );
}